import React from 'react';
import SalesresultsStaticsContainer from '../../containers/salesresults_statics/SalesresultsStaticsContainer';
import BreadcrumbsContainer from '../../containers/common/breadcurmbs/BreadcrumbsContainer';

const SalesresultsStaticsPage = () => {
  return (
    <>
      <BreadcrumbsContainer title="경영정보/사업목표vs매출실적" icon="statistics" />
      <SalesresultsStaticsContainer />
    </>
  );
};

export default SalesresultsStaticsPage;
